import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['Improved confidence and self-esteem', 'Better focus and discipline', 'Increased strength, balance, and coordination', 'Practical self-defense skills', 'Positive community and mentorship'];
export function Benefits() {
  return <section className="py-24 bg-neutral-900 text-white overflow-hidden" data-id="element-25">
      <div className="container mx-auto px-4" data-id="element-26">
        <div className="flex flex-col lg:flex-row items-center gap-16" data-id="element-27">
          <motion.div className="lg:w-1/2" initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-28">
            <h2 className="text-3xl md:text-5xl font-bold mb-8" data-id="element-29">
              Benefits of Training in{' '}
              <span className="text-red-600" data-id="element-30">Taekwondo</span>
            </h2>

            <ul className="space-y-6 mb-10" data-id="element-31">
              {benefits.map((benefit, index) => <motion.li key={index} initial={{
              opacity: 0,
              x: -20
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: index * 0.1
            }} className="flex items-start" data-id="element-32">
                  <CheckCircle2 className="w-6 h-6 text-red-600 mr-4 flex-shrink-0 mt-1" data-id="element-33" />
                  <span className="text-xl font-medium text-gray-200" data-id="element-34">
                    {benefit}
                  </span>
                </motion.li>)}
            </ul>

            <p className="text-2xl font-semibold text-white mb-10 italic border-l-4 border-red-600 pl-6" data-id="element-35">
              Taekwondo helps students become stronger — physically, mentally,
              and emotionally.
            </p>

            <Button href="/signup" data-id="element-36">Get Started Today</Button>
          </motion.div>

          <motion.div className="lg:w-1/2 relative" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-37">
            <div className="absolute -inset-4 bg-red-700/20 rounded-full blur-3xl" data-id="element-38" />
            <img src="https://cdn.magicpatterns.com/uploads/7zYPZvnrSn79caTQgzpU9k/stress-relief-using-martial-arts.webp" alt="Martial Arts Training Benefits" className="relative rounded-lg shadow-2xl border-4 border-neutral-800" data-id="element-39" />
          </motion.div>
        </div>
      </div>
    </section>;
}